import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "block w-full" }
const _hoisted_2 = { class: "flex items-center justify-between h-16 bg-neutral-100 rounded w-full overflow-hidden" }
const _hoisted_3 = { class: "flex items-center space-x-2" }
const _hoisted_4 = { class: "flex items-center space-x-2 p-2" }
const _hoisted_5 = ["src"]
const _hoisted_6 = { class: "" }
const _hoisted_7 = { class: "font-bold leading-tight" }
const _hoisted_8 = { class: "block truncate text-xs text-black/50" }
const _hoisted_9 = { class: "relative flex self-stretch space-x-2 p-2 transform translate-x-8" }
const _hoisted_10 = { class: "absolute z-10 right-1 top-1/2 transform -translate-y-1/2 -translate-x-8 bg-black/60 text-white font-bold p-1 text-xs rounded-full shadow-2xl" }
const _hoisted_11 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("li", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("img", {
            class: "w-8 h-8 rounded-full",
            src: _ctx.creator.avatar,
            alt: ""
          }, null, 8, _hoisted_5),
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("h5", _hoisted_7, _toDisplayString(_ctx.creator.name), 1),
            _createElementVNode("span", _hoisted_8, _toDisplayString("@" + _ctx.creator.username), 1)
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_9, [
        _createElementVNode("div", _hoisted_10, [
          _createElementVNode("span", null, "+ " + _toDisplayString(_ctx.creator.collections.length - 2), 1)
        ]),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.creator.collections.slice(0, 2), (src) => {
          return (_openBlock(), _createElementBlock("img", {
            class: "self-stretch rounded",
            key: src,
            src: src,
            alt: ""
          }, null, 8, _hoisted_11))
        }), 128))
      ])
    ])
  ]))
}